import { ConsentId } from '@/shared/enums';
import EventType from './event-type';

export default {
  [EventType.AD_CLICKED]: [ConsentId.PERFORMANCE],
  [EventType.AD_FINISHED]: [ConsentId.PERFORMANCE],
  [EventType.AD_STARTED]: [ConsentId.PERFORMANCE],
  [EventType.START_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.PAUSE_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.STOP_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.BUFFERING_WHILE_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.ERROR_WHILE_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.CHANGE_PLAYING_SETTINGS]: [ConsentId.PERFORMANCE],
  [EventType.APP_LANGUAGE_CHANGE]: [ConsentId.TARGETING],
  [EventType.ADD_TO_FAVORITES]: [ConsentId.TARGETING],
  [EventType.LOGIN]: [ConsentId.STRICTLY_NECESSARY],
  [EventType.LOGOUT]: [ConsentId.STRICTLY_NECESSARY],
  [EventType.CHANGE_PROFILE]: [ConsentId.STRICTLY_NECESSARY],
  [EventType.SHOW_SIGN_UP_FORM]: [ConsentId.FUNCTIONAL],
  [EventType.POPUP_SHOW]: [ConsentId.FUNCTIONAL],
  [EventType.POPUP_CLOSE]: [ConsentId.FUNCTIONAL],
  [EventType.POPUP_CLICK]: [ConsentId.FUNCTIONAL],
  [EventType.SHOW_APP_VIEW]: [ConsentId.FUNCTIONAL],
};
